import { Button } from "antd";
import { PhoneOutlined, ClockCircleOutlined, TeamOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { SyncData } from "./SyncData";
import dayjs from "dayjs";
import "./style.css";

const ReservationsManagementPanel = ({
  activeFeatureTab,
  setActiveFeatureTab,
  reservationList,
  filteredReservations,
  filteredWaitlist,
  countNewReservations,
  loadReservations,
  loadWaitlistForUI,
  setWaitlistList,
  setWaitlistTab,
  setWaitlistDrawerOpen,
  resetWaitlistForm,
  handleReserveTable,
  setSelectedReservation,
  setCheckInDrawerOpen,
  saveToWaitlist,
  setSeatGuestDrawerOpen,
  setSelectedWaitlistGuest,
}) => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        background: "#fff",
        padding: "20px",
        overflowY: "auto",
      }}
    >
      {/* ---------- Title ---------- */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 20,
          width: "100%",
        }}
      >
        <h1 className="reservations-title" style={{ fontSize: 28, fontWeight: 700, margin: 0 }}>Reservations Management</h1>
      </div>

      {/* ---------- Tabs ---------- */}
      <div style={{ display: "flex", gap: 12, marginBottom: 20 }}>
        <div
          className="reservations-tab"
          onClick={() => {
            setActiveFeatureTab("reservations");
            loadReservations();
          }}
          style={{
            padding: "10px 20px",
            borderRadius: 16,
            background: activeFeatureTab === "reservations" ? "#2F3856" : "#F4F4F5",
            color: activeFeatureTab === "reservations" ? "#fff" : "#000",
            fontWeight: 500,
            cursor: "pointer",
          }}
        >
          Reservations {countNewReservations}
        </div>

        <div
          className="reservations-tab"
          onClick={async () => {
            setActiveFeatureTab("waitlist");
            const list = await loadWaitlistForUI();
            setWaitlistList(list);
          }}
          style={{
            padding: "10px 20px",
            borderRadius: 16,
            background: activeFeatureTab === "waitlist" ? "#2F3856" : "#F4F4F5",
            color: activeFeatureTab === "waitlist" ? "#fff" : "#000",
            fontWeight: 500,
            cursor: "pointer",
          }}
        >
          Waitlist {filteredWaitlist.length}
        </div>
      </div>

      {/* ---------- Showing Count + Action Button ---------- */}
      {activeFeatureTab === "reservations" && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 20,
            marginTop: 5,
          }}
        >
          <p style={{ fontSize: 14, fontWeight: 500, color: "#444", margin: 0 }}>
            Showing {countNewReservations} reservations
          </p>
          <Button
            style={{
              background: "#2F3856",
              color: "#fff",
              borderRadius: 10,
              padding: "0 20px",
              height: 32,
              fontWeight: 600,
            }}
            onClick={handleReserveTable}
          >
            Reserve Table
          </Button>
        </div>
      )}

      {activeFeatureTab === "waitlist" && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 20,
            marginTop: 5,
          }}
        >
          <p style={{ fontSize: 14, fontWeight: 500, color: "#444", margin: 0 }}>
            Showing {filteredWaitlist.length} waitlist
          </p>
          <Button
            style={{
              background: "#2F3856",
              color: "#fff",
              borderRadius: 10,
              padding: "0 20px",
              height: 32,
              fontWeight: 600,
            }}
            onClick={() => {
              setWaitlistTab("add");
              setWaitlistDrawerOpen(true);
              resetWaitlistForm();
            }}
          >
            New Waitlist
          </Button>
        </div>
      )}

      {/* ---------- Reservation List ---------- */}
      {activeFeatureTab === "reservations" && (
        <div style={{ maxHeight: "60vh", overflowY: "auto", paddingRight: 10 }}>
          {(() => {
            const newCount = filteredReservations.filter((res) => res.status !== "CL").length;

            if (filteredReservations.length > 0 && newCount === 0) {
              return (
                <p style={{ textAlign: "center", color: "#888", marginTop: 30 }}>
                  No reservations found
                </p>
              );
            }

            if (filteredReservations.length === 0) {
              return (
                <p style={{ textAlign: "center", color: "#888", marginTop: 30 }}>
                  No reservations found
                </p>
              );
            }

            return filteredReservations
              .filter((res) => res.status !== "CL")
              .map((res, index) => (
                <div
                  key={index}
                  className="reservation-card"
                  style={{
                    border: "1px solid #E5E7EB",
                    padding: "20px",
                    borderRadius: 12,
                    marginBottom: 20,
                  }}
                >
                  <div className="reservation-card-body" style={{ display: "flex", justifyContent: "space-between" }}>
                    <div>
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <span className="reservation-card-name" style={{ fontSize: "15px", fontWeight: 500 }}>{res.name}</span>
                        <span
                          className="reservation-card-status"
                          style={{
                            background: res.status === "confirmed" ? "#C7F9CC" : "#FFE8A3",
                            color: "#333",
                            padding: "2px 10px",
                            fontSize: "13px",
                            borderRadius: 8,
                          }}
                        >
                          {res.status === "OCU"
                            ? "Occupied"
                            : res.status === "STD"
                            ? "Seated"
                            : res.status}
                        </span>
                      </div>
                      <div className="reservation-card-info" style={{ marginTop: 8, display: "flex", gap: 25 }}>
                        <span><PhoneOutlined /> {res.phone}</span>
                        <span><ClockCircleOutlined /> {res.time}</span>
                        <span><TeamOutlined /> {res.guests} guests</span>
                      </div>
                    </div>

                    <div className="reservation-card-actions" style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <Button
                        icon={<CheckOutlined />}
                        style={{
                          background: "#2F3856",
                          color: "#fff",
                          borderRadius: 10,
                          padding: "0 18px",
                          height: 40,
                          display:
                            res.status === "OCU" || res.status === "STD" ? "none" : "",
                        }}
                        onClick={() => {
                          setSelectedReservation(res);
                          setCheckInDrawerOpen(true);
                        }}
                      >
                        Check In
                      </Button>

                      <Button
                        icon={<CloseOutlined />}
                        style={{ borderRadius: 10, padding: "0 18px", height: 40 }}
                        onClick={() => {
                          let reserve = res;
                          reserve.status = "CL";
                          SyncData(reserve, "reservation");
                        }}
                      >
                        No Show
                      </Button>
                    </div>
                  </div>
                </div>
              ));
          })()}
        </div>
      )}

      {/* ---------- Waitlist ---------- */}
      {activeFeatureTab === "waitlist" && (
        <div style={{ maxHeight: "60vh", overflowY: "auto", paddingRight: 10 }}>
          {console.debug("filteredWaitlist ==========>", filteredWaitlist)}
          {filteredWaitlist.length === 0 ? (
            <p style={{ textAlign: "center", color: "#888", marginTop: 40 }}>
              No guests in waitlist
            </p>
          ) : (
            filteredWaitlist.map((guest, index) => (
              <div
                key={index}
                className="reservation-card"
                style={{
                  border: "1px solid #E5E7EB",
                  padding: "20px",
                  borderRadius: 12,
                  marginBottom: 20,
                }}
              >
                <div className="reservation-card-body" style={{ display: "flex", justifyContent: "space-between" }}>
                  <div>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <span className="reservation-card-name" style={{ fontSize: "15px", fontWeight: 500 }}>{guest.name}</span>
                      <span
                        className="reservation-card-status"
                        style={{
                          padding: "2px 10px",
                          fontSize: "13px",
                          borderRadius: 8,
                          background:
                            guest.status === "STD"
                              ? "#DBEAFE"
                              : guest.status === "CL"
                              ? "#E5E7EB"
                              : guest.notified
                              ? "#C7F9CC"
                              : "#FFE8A3",
                          color:
                            guest.status === "STD"
                              ? "#1E3A8A"
                              : guest.status === "CL"
                              ? "#374151"
                              : "#333",
                        }}
                      >
                        {guest.status === "WAT"
                          ? `Waiting • ${guest.eta} min`
                          : guest.status === "STD"
                          ? "Seated"
                          : guest.status === "CL"
                          ? "Closed"
                          : guest.notified
                          ? "Notified"
                          : guest.eta
                          ? `Waiting • ${guest.eta} min`
                          : "Waiting"}
                      </span>
                    </div>
                    <div className="reservation-card-info" style={{ marginTop: 8, display: "flex", gap: 25 }}>
                      <span><PhoneOutlined /> {guest.phone}</span>
                      <span><TeamOutlined /> {guest.guests} guests</span>
                    </div>
                  </div>

                  <div className="reservation-card-actions" style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    {guest.status !== "STD" && (
                      <Button
                        icon={<CheckOutlined />}
                        style={{
                          background: "#2F3856",
                          color: "#fff",
                          borderRadius: 10,
                          padding: "0 18px",
                          height: 40,
                        }}
                        onClick={() => {
                          setSelectedWaitlistGuest(guest);
                          setSeatGuestDrawerOpen(true);
                        }}
                      >
                        Seat Guest
                      </Button>
                    )}
                    <Button
                      icon={<CloseOutlined />}
                      style={{ borderRadius: 10, padding: "0 18px", height: 40 }}
                      onClick={() => saveToWaitlist({ ...guest, waitlistId: guest.id, status: "CL" })}
                    >
                      Close
                    </Button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default ReservationsManagementPanel;
